const mapTrackingFromAPI = ({
  publicUrl,
  code
}) => ({
  publicUrl,
  code
})

const mapTrackingForUpsert = ({
  publicUrl,
  code
}) => ({
  publicUrl,
  code
})

export default {
  mapTrackingFromAPI,
  mapTrackingForUpsert
}
